import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MaterialPage = _resolveComponent("MaterialPage");
  const _component_el_row = _resolveComponent("el-row");
  return $data.permissions.includes('MATERIALS_DASHBOARD') ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "DashboardViewContainer"
  }, {
    default: _withCtx(() => [$options.boomType ? (_openBlock(), _createBlock(_component_MaterialPage, {
      key: 0,
      "boom-type": true
    })) : (_openBlock(), _createBlock(_component_MaterialPage, {
      key: 1,
      "boom-type": null
    }))]),
    _: 1
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("span", null, "不可访问", -1)])));
}